module.exports = __webpack_public_path__ + "static/media/our-tests-image-02.59b21651.jpg";